import React from 'react';
import { Card } from 'antd';

export default class Overview extends React.Component {
    render() {
        return (
            <Card>Admin Overview</Card>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/admin/Overview.tsx